<template>
  <tr class="border_bottom">
    <td colspan="2">
      <table>
        <tr>
          <td colspan="2">
            <font align="left" style="text-align: left; font-weight: bold; font-size: 18px; color: #000000">
              Your booking voucher for:
            </font>
            <br />
          </td>
        </tr>
        <tr>
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td colspan="2">
            <font align="left" style="text-align: left; font-weight: bold; font-size: 16px; color: #000000">
              {{ item.product.park_name || item.product.product_name }}
            </font>
          </td>
        </tr>
        <tr>
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;"><hr/></td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size:16px; color:#000000;">
              Booking Reference:                
              <span style="font-size: 20px;" :style="{'text-decoration': item.booking.booking_mode == 'Cancelled' ? 'line-through' : 'none' }">
                 <strong>{{ item.booking.booking_ref }}</strong>
              </span>
            </font>
          </td>
          <td style="vertical-align: top;" v-if="item.booking.booking_mode != 'Cancelled'">
            <img
              :src="`https://chart.googleapis.com/chart?chl=${item.booking.booking_ref}&choe=UTF-8&chs=150x150&cht=qr`"
              title="QR code"
              align="right"
            />
          </td>
        </tr>
        <tr>
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;"><hr/></td>
        </tr>
        <tr v-if="item.booking.product_id == '841' || item.booking.product_id == '720' && item.booking.save_quote_code">
          <td colspan="2" >
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Space Number: {{ item.booking.save_quote_code.slice(5, 10) }}
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.save_quote_code">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Pin Code For Barrier: {{ item.booking.save_quote_code.slice(0, 4) }}
            </font>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <strong v-if="item.booking.booking_mode == 'Cancelled'">
              <span style="font-weight:bold; color:#FF0000; font-size: 14px;">
                <strong>Status:</strong> {{ item.booking.booking_mode }}
              </span>
            </strong>
            <strong v-else>
              <span style="font-weight:bold; color:#00638c; font-size: 14px;">
                <strong>Status:</strong> {{ item.booking.booking_mode }}
              </span>
            </strong>
          </td>
        </tr>
        <tr>
          <td colspan="2" height="10" style="line-height:10px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <strong>Travel date:</strong> {{ travelDate }}
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.meet_time">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <strong>Meet time:</strong> {{ item.booking.meet_time }}
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.outbound_terminal || item.booking.outbound_flight">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;" >
              <strong>Outbound terminal:</strong> {{ terminalShorten(item.booking.outbound_terminal) }} / Outbound flight: {{ item.booking.outbound_flight }}
            </font>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <strong>Return date:</strong> {{ returnTime }}
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.return_terminal || item.booking.return_flight_number">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <strong>Return terminal:</strong> {{ terminalShorten(item.booking.return_terminal) }} / Return flight: {{ item.booking.return_flight_number }}
            </font>
          </td>
        </tr>
        <tr>
          <td colspan="2" height="10" style="line-height:10px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td colspan="2">
            <font style="font-weight: bold; font-size: 16px; color:#000000;">
              Car details:
            </font>
          </td>
        </tr>
        <tr>
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.passengers > 0">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <strong>Passengers:</strong> {{ item.booking.passengers }}
            </font>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <strong>Vehicle registration:</strong> {{ item.booking.vehicle_reg }}
            </font>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <strong>Model:</strong> {{ item.booking.vehicle_make }} {{ item.booking.vehicle_model }} / <strong>Vehicle colour:</strong> {{ item.booking.vehicle_colour }}
            </font>
          </td>
        </tr>
        <tr>
          <td colspan="2" height="10" style="line-height:10px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2">
            <font style="font-weight: bold; font-size: 16px; color:#000000;">Arrival Procedure:</font>
          </td>
        </tr>
        <tr>
          <td colspan="2" height="10" style="line-height:10px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.booking.save_quote_code && item.booking.saved_quote_code && item.booking.saved_quote_code.indexOf(',') !== -1">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <strong>Pin Code For Barrier:</strong> {{item.booking.save_quote_code.slice(0,4) }}
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.booking.save_quote_code && item.booking.saved_quote_code && item.booking.saved_quote_code.indexOf(',') !== -1">
          <td colspan="2">
            <font
              style="font-weight: normal; font-size: 14px; color:#000000;">
              Space Number: {{ item.booking.save_quote_code.slice(5,10) }}
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;" v-html="item.product.conf_arrival" />
          </td>
        </tr> 
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2">
            <font style="font-weight: bold; font-size: 16px; color:#000000;">Car Park:</font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Phone Number: {{ item.product.customer_telephone }}
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2">
            <font style="font-weight: bold; font-size: 16px; color:#000000;">Return Procedure:</font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;" v-html="item.product.conf_departure" />
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2">
            <font style="font-weight: bold; font-size: 16px; color:#000000;">Address:</font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2">
            <font
              style="font-weight: normal; font-size: 14px; color:#000000;"
            >{{ item.product.customer_address }}</font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2">
            <font style="color: rgb(0, 0, 255); font-weight: bold; font-size: 14px;">
              <a :href="`https://www.google.com/maps?q=${item.product.latitude},${item.product.longitude}`">
                {{ item.product.customer_postcode }}
              </a>
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Please note Post Codes do not always take you to the correct location when using SatNavs.
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              Please use in conjunction with the directions below:
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2">
            <font style="font-weight: bold; font-size: 16px; color:#000000;">
              Directions:  
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2">
            <font style="font-weight: bold; font-size: 12px; color: rgb(50, 50, 50);">
              Directions link -
              <a :href="`https://www.google.com/maps?q=${item.product.latitude},${item.product.longitude}`" style="color: rgb(0, 0, 255);">
                Find using Google Maps
              </a>
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2">
            <font v-html="item.product.conf_directions" style="font-weight: normal; font-size: 14px; color:#000000;"></font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.park_type == 'Park and Ride'">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.important_info != ''">
          <td colspan="2">
            <font
              style="font-weight: bold; font-size: 16px; color:#000000;"
            >IMPORTANT INFORMATION REGARDING THE CAR PARK</font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.important_info != ''">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled' && item.product.important_info != ''">
          <td colspan="2">
            <font v-html="item.product.important_info" style="font-weight: normal; font-size: 14px; color:#000000;"></font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'  && item.product.important_info != ''">
          <td colspan="2" height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'  && item.product.important_info != ''">
          <td colspan="2">
            <font style="font-weight: bold; font-size: 16px; color:#000000;">
              To see Carpark Terms and Conditions please go to the link below:
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'  && item.product.important_info != ''">
          <td colspan="2">
            <font style="font-weight: normal; font-size: 14px; color:#000000;">
              <a
                :href="`https://legacy.skyparksecure.com/product-terms/${item.product.product_tcs}`"
                style="color: rgb(0, 0, 255);"
              >Product terms and conditions</a>
            </font>
          </td>
        </tr>
        <tr v-if="item.booking.booking_mode != 'Cancelled'">
          <td colspan="2">
            <br :style="{ 'page-break-before': airportparking.length > 1 ? 'always' : 'initial' }" />
          </td>
        </tr>
      </table>
    </td>
  </tr>
</template>

<script>
import mixins from "@/mixins";
import moment from "moment";

export default {
  name: "confirmation-view-parking",
  mixins: [mixins.format],
  computed: {
    returnTime() {
      return moment(this.item.booking.return_date_time).format('Do MMM YYYY, HH:mm')
    },
    travelDate() {
      return moment(this.item.booking.departure_date_time).format('Do MMM YYYY, HH:mm')
    }
  },
  props: {
    item: { type: Object, default: () => {} },
    airportparking: { type: Number, default: 1 }
  }
};
</script>